import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Checkboxes from '../checkboxes';
import { ListFilterItem } from 'src/components/filter-section/types';
import { OptionList } from 'src/components/filter-section/components/list/styles';
import * as S from './styles';

type Props = {
  getSelectedState: (id: string) => boolean;
  handleOnClick: (id: string, value: string) => void;
  selectedItems: ListFilterItem[];
};

export const SelectedFilters = (props: Props) => {
  const { getSelectedState, handleOnClick, selectedItems } = props;
  const { t } = useContext(AppContext);

  return (
    <S.SelectedFiltersWrapper>
      <S.SelectedFiltersTitle>
        {t('filter', 'applied-filters.title')}
      </S.SelectedFiltersTitle>
      <OptionList>
        <Checkboxes
          items={selectedItems}
          getSelectedState={getSelectedState}
          onClickItem={handleOnClick}
        />
      </OptionList>
    </S.SelectedFiltersWrapper>
  );
};
